import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'smart-tools.smart-spot-fill-chart.title',
    defaultMessage: 'How SmartSpot helps fill classes that have less direct demand',
  },
  subtitle: {
    id: 'smart-tools.smart-spot-fill-chart.subtitle',
    defaultMessage: 'SmartSpot drives most demand in classes that have fewer direct bookings',
  },
  timeframe: {
    id: 'smart-tools.smart-spot-fill-chart.timeframe',
    defaultMessage: 'Last 30 days',
  },
  xAxisLabel: {
    id: 'smart-tools.smart-spot-fill-chart.x-axis-label',
    defaultMessage: 'Classes Grouped by Direct Member Fill Rate',
  },
  legendDirectFill: {
    id: 'smart-tools.smart-spot-fill-chart.legend.direct-fill',
    defaultMessage: 'Direct fill',
  },
  legendSmartSpotFill: {
    id: 'smart-tools.smart-spot-fill-chart.legend.smartspot-fill',
    defaultMessage: 'SmartSpot fill',
  },
  legendNoData: {
    id: 'smart-tools.smart-spot-fill-chart.legend.no-data',
    defaultMessage: 'No data',
  },
  infoTooltip: {
    id: 'smart-tools.smart-spot-fill-chart.info-tooltip',
    defaultMessage: 'This chart looks at SmartSpot bookings relative to how full classes were with your members',
  },
});
